// import store from '@/store';
const getters = {
  getSearchedStudentHistory: (state) => state.searchedStudentHistory,
  getStudentAlerts: (state) => state.alerts,
  getStudentPreRegistry: (state) => state.selectedStudentPreRegistry,
  getStudentPreRegistryValidations: (state) =>
    state.studentPreRegistryValidations,
  getRegister: (state) => state.register,
  getRegStudentId: function(state) {
    return state.regStudentId;
  },
  SelectedStudent: function(state) {
    return state.selectedStudent;
  },
  StudentSie: function(state) {
    return state.selectedStudent?.studentId;
  },
  GetStatusModal: function(state) {
    return state.ShowModal;
  },
  getMipeStudent: function(state) {
    return state.details;
  },
};

export default getters;
